import type { StatusChipProps } from '@components/v2/ui/StatusChip/StatusChip';
import {
  ApprovedDot,
  CanceledDot,
  DraftDot,
  InApprovalDot,
  InReviewDot,
} from '@components/v2/ui/StatusChip/components/statusIcon.icons';
import LangEnum from '../../../lang/LangEnum';
import { TargetStatus } from '../../../services/modules/target/target.types';

export const TARGET_STATUS_CHIP_CONFIG: Record<TargetStatus, Omit<StatusChipProps, 'size'>> = {
  [TargetStatus.SUGGESTED]: {
    label: LangEnum.TARGET_STATUS_SUGGESTED,
    icon: InReviewDot,
    color: 'waiting',
  },
  [TargetStatus.DRAFT]: {
    label: LangEnum.TARGET_STATUS_DRAFT,
    icon: DraftDot,
    color: 'neutral',
  },
  [TargetStatus.OPEN]: {
    label: LangEnum.TARGET_STATUS_OPEN,
    icon: InApprovalDot,
    color: 'progress',
  },
  [TargetStatus.CLOSED]: {
    label: LangEnum.TARGET_STATUS_CLOSED,
    icon: ApprovedDot,
    color: 'closed',
  },
  [TargetStatus.CLOSED_WON]: {
    label: LangEnum.TARGET_STATUS_CLOSED_WON,
    icon: ApprovedDot,
    color: 'success',
  },
  [TargetStatus.CLOSED_LOST]: {
    label: LangEnum.TARGET_STATUS_CLOSED_LOST,
    icon: CanceledDot,
    color: 'closed',
  },
  [TargetStatus.CANCELED]: {
    label: LangEnum.TARGET_STATUS_CANCELED,
    icon: CanceledDot,
    color: 'closed',
  },
};
